import { memo, useCallback, useState } from "react";
import toast from "react-hot-toast";
import { useCreateCourse } from "../../../../hooks/query/useCreateCourse";
import { useGetAllCourse } from "../../../../hooks/query/useGetAllCourse";
import InputText from "../../../InputText";
import WarningDeleteCoursePopup from "../../../WarningDeleteCoursePopup";
import CourseTag from "../../CourseTag";

function Course() {
    const [title, setTitle] = useState("");
    const [description, setDescription] = useState("");
    const [show, setShow] = useState<boolean>(false);
    const [courseId, setCourseId] = useState<number | null>(null);
    const { data, isLoading } = useGetAllCourse(1,10);
    const { mutate: createCourse } = useCreateCourse();

    const handleCreateBranch = useCallback(() => {
        createCourse(
            { title, description, duration: 1, price: 0, prerequisiteCourseIds: [] },
            {
                onSuccess: () => {
                    setTitle("");
                    setDescription("");
                    toast.success("Tạo khóa học thành công!");
                },
            }
        );
    }, [title, description, createCourse]);

    const handleDeleteCourse = (courseId: number) => {
        setShow(true);
        setCourseId(courseId);
    }

    const handleCloseDeletePopup = () => {
        setShow(false);
        setCourseId(null);
    };

    return (
        <div className="mt-[20px] w-full h-full">
            {show && (<WarningDeleteCoursePopup
                courseId={courseId}
                onClose={handleCloseDeletePopup}
                onCancel={handleCloseDeletePopup}
                onSuccess={() => {
                    toast.success("Xóa khoá học thành công!");
                }}
            />)}
            <div>
                <h1 className="font-bold text-[20px] text-center">Tạo mới khóa học</h1>
                <div className="w-[30%] mt-[20px]">
                    <InputText value={title} onChange={(e) => setTitle(e.target.value)} label="Tên khóa học" placeholder="Nhập tên khóa học..." name="title" inputStyle="text-black" />
                    <InputText value={description} onChange={(e) => setDescription(e.target.value)} label="Mô tả khóa học" placeholder="Nhập mô tả khóa học" name="description" inputStyle="text-black" />
                    <button onClick={handleCreateBranch} className="mt-[15px] bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded">Tạo khóa học</button>
                </div>
                <div>
                    <hr className="my-6" />
                    <h2 className="font-bold text-[20px] my-[10px] text-center">Danh sách khóa học</h2>
                    {isLoading && <p>Loading...</p>}
                    <div className="space-y-2">
                        {data?.data?.items
                            ?.slice()
                            .sort((a: any, b: any) => a.id - b.id)
                            .map((course: any) => (
                                <CourseTag
                                    key={course.id}
                                    course={course}
                                    onEdit={(id: number) => { }}
                                    onDelete={(id: number) => {
                                        handleDeleteCourse(id);
                                    }}
                                />
                            ))}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default memo(Course);